"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lux = void 0;
var UnitDivide = require("../unit-divide");
var luminous_flux_1 = require("./luminous-flux");
var area_1 = require("./area");
/**
 * The derived unit for illuminance ( <code>lx</code> ).
 * One Lux is equal to one lumen per square meter.
 */
exports.Lux = UnitDivide.luminousFluxByArea("Lux", luminous_flux_1.Lumen, area_1.SquareMeter);
//# sourceMappingURL=illuminance.js.map